module.exports = __webpack_public_path__ + "static/media/iv-player-icons.2a07a263.ttf";